import {makeAutoObservable} from "mobx";

export default class AnalyticsStore {
    constructor() {
        this._data = [
            {
                id: '123',
                key: '123',
                name: '123',
                model: '123',
                serialNumber: '123',
                equipment: {
                    description: "-",
                    facility: "-",
                    manufacturer: "-",
                    model: "-",
                    sn: "-",
                    type: "-",
                    city: "-",
                    address: "-",
                },
                settings: {
                    current_factor: 1.0,
                    voltage_factor: 1.0,
                }
            }
        ]
        this._messages = {
            voltage: [
                {
                    x: 0,
                    y: 0
                }
            ],
            current: [
                {
                    x: 0,
                    y: 0
                }
            ],
            temperature: [
                {
                    x: 0,
                    y: 0
                }
            ],
            humidity: [
                {
                    x: 0,
                    y: 0
                }
            ],
            power: [
                {
                    x: 0,
                    y: 0
                }
            ]

        }
        this._totalVoltage = 0
        this._totalCurrent = 0
        this._totalTemperature = 0
        this._totalHumidity = 0
        this._fetchList = []
        makeAutoObservable(this)
    }

    setData(newData) {
        this._data = newData
    }

    setMessages(action, newData) {
        switch (action) {
            case 'voltage':
                this._messages.voltage = newData
                break;
            case 'current':
                this._messages.current = newData
                break;
            case 'temperature':
                this._messages.temperature = newData
                break;
            case 'humidity':
                this._messages.humidity = newData
                break;
            case 'power':
                this._messages.power = newData
                break;
            default:
                return;
        }
    }

    setTotalVoltage(value) {
        this._totalVoltage = value
    }

    setTotalCurrent(value) {
        this._totalCurrent = value
    }

    setTotalTemperature(value) {
        this._totalTemperature = value
    }

    setTotalHumidity(value) {
        this._totalHumidity = value
    }

    setFetchList(value) {
        this._fetchList = value
    }

    get data() {
        return this._data
    }

    get messages() {
        return this._messages
    }

    get totalVoltage() {
        return this._totalVoltage
    }

    get totalCurrent() {
        return this._totalCurrent
    }

    get totalTemperature() {
        return this._totalTemperature
    }

    get totalHumidity() {
        return this._totalHumidity
    }

    get fetchList() {
        return this._fetchList
    }
}